module.exports = __webpack_public_path__ + "static/img/logo05.1b4d47d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo05.png
// module id = sbRY
// module chunks = 0